import React from 'react';
import PropTypes from 'prop-types';
import InvoiceTextField from '../../../../InvoiceTextField';
import { basicInfoFieldsRows, uneditableFields } from '../InvoiceLineFieldsHelper';

const flexInputsColumnStyle = { flex: 1, marginLeft: 24, marginBottom: 10 };
const flexFirstColumnStyle = { flex: 1, marginBottom: 10 };

const InvoiceLineBasicInfoSection = props => (
  <React.Fragment>
    <h1 className="invoice-line-section-title">Basic information</h1>
    {
      basicInfoFieldsRows.map((row, rowIndex) => (
        <div key={ rowIndex } style={ { display: 'flex' } }>
          {
            row.map((field, fieldIndex) => (
              <InvoiceTextField
                key={ field.key }
                name={ field.key }
                label={ field.label }
                value={ props.basicInfoData[field.key] }
                onChange={ (ev, value, errorMessage) => props.onFieldChange(ev, value, errorMessage) }
                fullWidth={ true }
                style={
                  fieldIndex === 0
                    ? flexFirstColumnStyle
                    : flexInputsColumnStyle
                }
                disabled={
                  uneditableFields.some(uneditableField => uneditableField === field.key)
                }
                dataType={ field.dataType }
                stringMaxLength={ field.stringMaxLength || '' }
              />
            ))
          }
        </div>
      ))
    }
  </React.Fragment>
);

InvoiceLineBasicInfoSection.propTypes = {
  basicInfoData: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

export default InvoiceLineBasicInfoSection;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/invoiceLineEditorSections/InvoiceLineBasicInfoSection.js